import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { Dimensions, StyleSheet, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import {
    LineSegment,
    VictoryAxis,
    VictoryBar,
    VictoryChart,
    VictoryTheme,
    VictoryTooltip,
    VictoryZoomContainer
} from "victory"

const { width, hieght } = Dimensions.get("screen")
export const CustomBarChart = (props) => {
    const { data, loading } = props
    const series = data

    return (
        <View style={styles.container}>
            <View
                style={{
                    flex: 1,
                    alignItems: "flex-start",
                    display: "flex",
                    justifyContent: "flex-start",
                    width: width - 40
                }}
            >
                <OpenSansText
                    color={baseColors.black}
                    style={{ textAlign: "left", marginTop: 20, marginLeft: 5 }}
                    fontSize={20}
                >
                    {props.title}
                </OpenSansText>
                <OpenSansText
                    color={baseColors.green.primary}
                    style={{ textAlign: "left", marginTop: 20, marginLeft: 5, marginBottom: -30 }}
                    fontSize={15}
                >
                    {props.valueType}
                </OpenSansText>
            </View>

            <VictoryChart domainPadding={{ x: 10 }} width={width} theme={VictoryTheme.material}>
                <VictoryBar
                    //labelComponent={<VictoryTooltip />}
                    style={{
                        data: {
                            fill: ({ datum }) => {
                                return datum.value < 15 ? baseColors.orange.primary : baseColors.green.primary
                            }
                        }
                    }}
                    cornerRadius={{ top: 8 }}
                    data={series}
                    x="date"
                    y="value"
                />
                <VictoryAxis
                    dependentAxis
                    style={{
                        grid: { stroke: "#718096", strokeDasharray: "2 10" },
                        tickLabels: { fontSize: 8 }
                    }}
                    tickCount={8}
                ></VictoryAxis>
                <VictoryAxis
                    style={{
                        grid: { stroke: "rgba(0,0,0,0)", strokeDasharray: "2 10" },
                        tickLabels: { fontSize: 8 }
                    }}
                    tickCount={8}
                ></VictoryAxis>
            </VictoryChart>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 8,
        backgroundColor: baseColors.green.light
    }
})
